<template>
    <div class='headerSerc'>
        <tab @getTab="getTab"></tab>
        <div id='content' v-if="status === 'content'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.menuConfig.title}}</span>
                <menusConfig :setTingObj="setTingObj"></menusConfig>
            </div>
        </div>
        <div id='style' v-if="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgStyle.title}} ({{setTingObj.bgStyle.list[setTingObj.bgStyle.type].val}})</span>
                <radio :list="setTingObj.bgStyle.list" :type="setTingObj.bgStyle.type" @change="updateBgStyle"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.lrEdge.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.lrEdge"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.mbConfig.title}}</span>
                <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
            </div>
        </div>
    </div>
</template>

<script>
import tab from '@/components/decoration/common/tab.vue'
import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
import radio from '@/components/decoration/common/radio.vue';
import menusConfig from '@/components/decoration/common/menusConfig.vue';

export default {
    components: {
        menusConfig,
        radio,
        sliderAndInput,
        tab,
    },
    props: {
        setTingObj: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            status: 'content'
        };
    },
    methods: {
        getTab(e) {
            this.status = e
        },
        updateBgStyle(type){
            this.setTingObj.bgStyle.type = type
        },
    }
};
</script>

<style lang='scss' scoped>

</style>